import React from 'react';
import { Link } from 'react-router-dom';
import useNavData, { VIEW_LABELS, VIEW_PATHS, ViewKey } from 'components/molecules/navData';

type Props = {
    wrapperStyle?: string;
    itemStyle?: string;
    onNavigate?: () => void;
}

const VIEWS: ViewKey[] = ['portfolio', 'brand'];

const ViewSwitcher: React.FC<Props> = (props) => {
    const { currentView } = useNavData();

    return (
        <div
            className={`flex items-center gap-1 rounded-full border border-Primary/40 bg-Primary_Accents_2xs p-1 ${props.wrapperStyle || ''}`}
        >
            {VIEWS.map((view) => {
                const isCurrent = view === currentView;

                return (
                    <Link
                        key={view}
                        to={VIEW_PATHS[view]}
                        aria-current={isCurrent ? 'page' : undefined}
                        onClick={props.onNavigate}
                        className={`px-3 py-1 rounded-full text-xs whitespace-nowrap transition ease-in-out duration-250 ${
                            props.itemStyle || ''
                        } ${
                            isCurrent
                                ? 'bg-Primary text-white'
                                : 'text-Primary hover:bg-Primary hover:text-white'
                        }`}
                    >
                        {VIEW_LABELS[view]}
                    </Link>
                );
            })}
        </div>
    );
};

export default ViewSwitcher;
